import { IRolePayload } from '@/types/payload';

import http from './http';
import serviceHelper from './serviceHelper';

export const getRolesList = async () => {
  return serviceHelper(http.get(`/admin/role`), false);
};

export const getAllSectionList = async () => {
  return serviceHelper(http.get('/admin/role/section'), false);
};

export const createRole = async (data: IRolePayload) => {
  return serviceHelper(http.post('/admin/role', data));
};

export const updateRole = async (id: string, data: IRolePayload) => {
  return serviceHelper(http.patch(`/admin/role/${id}`, data));
};

export const getRoleByID = async (id: string) => {
  return serviceHelper(http.get(`/admin/role/${id}`), false);
};
